import clsx from 'clsx';
import Image from '../Image/Image';

export default function Card({ children, className, image, imageAlt, onClick, subtitle, title, url }: CardProps) {

    const cardClasses = clsx('card', className);

    return <a className={cardClasses} href={url} onClick={onClick} rel="noreferrer" target="_blank">
        <div className="py-5 text-center">
            <Image alt={imageAlt || ''} src={image} />
        </div>
        <div className="bg-grey card-body p-4">
            <p className="fw-bold text-accent text-uppercase">{subtitle}</p>
            <h4 className="card-title text-black">{title}</h4>
            <p className="card-text text-muted" dangerouslySetInnerHTML={{ __html: children }} />
        </div>
    </a>;

}
